import blogReducer from "./blog";
import { configureStore } from "@reduxjs/toolkit";
import securityReducer from "./security";
import channelReducer from "./channel";
import roleReducer from "./role";
import administratorReducer from "./administrator";
import productReducer from "./product";
import categoryReducer from "./category";
import tagReducer from "./tag";
import courseReducer from "./course";
import videoReducer from "./video";
import sliderReducer from "./slider";
import sectionReducer from "./section";
import userReducer from "./user";
import menuReducer from "./menu";
import reelsReducer from "./reels";
import contactReducer from "./contact";
import pageReducer from "./page";
import mediaReducer from "./media";

const store = configureStore({
  reducer: {
    loggedUserReducer: securityReducer,
    blogReducer,
    roleReducer,
    channelReducer,
    administratorReducer,
    productReducer,
    categoryReducer,
    tagReducer,
    courseReducer,
    videoReducer,
    sliderReducer,
    sectionReducer,
    userReducer,
    menuReducer,
    reelsReducer,
    contactReducer,
    pageReducer,
    mediaReducer,
  },
});

export default store;
